<!--[enableDesktopMode] tut auf desktop nicht da dann das hochladen von Bildern im Unterschrift dialog nicht mehr funktioniert-->
<!--<ejs-pdfviewer-->
<!--    #pdfViewer-->
<!--    [serviceUrl]="ServiceUrl"-->
<!--    [toolbarSettings]="ToolbarSettings"-->
<!--    [inkAnnotationSettings]="inkAnnotationSettings"-->
<!--    [enableDesktopMode]="BS.TouchQuery | async"-->
<!--    [enableToolbar]="true"-->
<!--    [initialRenderPages]="20"-->
<!--    [enablePageOrganizer]="true"-->

<!--    (documentLoad)="documentLoad()"-->
<!--    (annotationAdd)="onAnnotationAdd($event)"-->
<!--    [enableZoomOptimization]="false"-->
<!--    style="height:100%;width:100%;display:block"-->
<!--&gt;</ejs-pdfviewer>-->
<ejs-pdfviewer
    #pdfViewer
    [toolbarSettings]="ToolbarSettings"
    [inkAnnotationSettings]="inkAnnotationSettings"
    [enableDesktopMode]="BS.TouchQuery | async"
    [enableTextSelection]="!(BS.TouchQuery | async)"
    [enableToolbar]="true"
    [initialRenderPages]="1"
    [enablePageOrganizer]="true"
    [resourceUrl]='resourceUrl'
    [serviceUrl]="ServiceUrl"
    (documentLoad)="documentLoad()"
    (annotationAdd)="onAnnotationAdd($event)"
    [enableZoomOptimization]="true"
    (ajaxRequestInitiate)="ajaxRequestInitiate($event)"
    style="height:100%;width:100%;display:block"
></ejs-pdfviewer>
<div class="save-button">
    <button app-round-button *ngIf="CheckedFile$ | async as file" [matTooltip]="file.Remark ? 'Bemerkung: ' + file.Remark : 'Bemerkung hinzufügen'" [attr.aria-label]="file.Remark" (click)="OpenRemark()"><fa-icon icon="exclamation-triangle"></fa-icon></button>
    <button app-round-button *ngIf="CheckedFile$ | async as file" [matTooltip]="file.Checked ? 'Ungeprüft setzen' : 'Geprüft setzen'"  [attr.aria-label]="file.Checked ? 'Ungeprüft setzen' : 'Geprüft setzen'" (click)="changeChecked()" [IsLoading]="LS.IsLoading$ | async"><fa-icon icon="check-to-slot"></fa-icon></button>
    <button app-round-button *ngIf="Editing" matTooltip="Unterschrift hinzufügen" aria-label="Unterschrift hinzufügen" (click)="OpenSignaturePopup();" [Disabled]="checkModeActive"><fa-icon icon="signature"></fa-icon></button>
    <button app-round-button *ngIf="Editing" matTooltip="Check hinzufügen" aria-label="Check hinzufügen" (click)="toggleAddCheckAnnotations();"><fa-icon [icon]="checkModeActive ? 'times' : 'check'"></fa-icon></button>
    <button app-round-button *ngIf="SaveButton" matTooltip="Speichern" aria-label="Speichern" (click)="Save()" [IsLoading]="LS.IsLoading$ | async"><fa-icon icon="save"></fa-icon></button>
    <button app-round-button matTooltip="Bearbeiten" aria-label=" Bearbeiten" (click)="Edit()"><fa-icon [icon]="this.Editing ? 'chevron-down' : 'pencil-alt'"></fa-icon></button>
</div>
<button style="position: absolute; bottom: 1rem; left: 1rem; z-index: 100" (click)="autosave()">autosave test</button>
